
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlet/flower-shops",
      function () {
        return require("private-next-pages/outlet/flower-shops.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlet/flower-shops"])
      });
    }
  